@import '../../../styles/colors.css';

h4 {
  margin-bottom: 32px;
}

#grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

#backNextContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 32px;
}

#successHeader {
  height: 132px;
  background-color: var(--white);
  padding: 24px;
  row-gap: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}

#successTitleContainer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  column-gap: 24px;
}

#successHeaderTitle {
  font-weight: bolder;
  border-bottom: 3px solid var(--tangerine);
  max-width: max-content;
}

#successIconContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60%;
  min-width: 400px;
}

#successStepperContainer {
  padding-top: 16px;
}

#summaryContainer {
  display: flex;
  flex-direction: column;
  margin: 16px;
  width: 66%;
  gap: 24px;
}

#viewContainer {
  display: flex;
  flex-direction: column;
  padding: 32px;
}

.autoMappingError {
  color: var(--red);
  font-weight: 600;
  margin: 0;
}

.bottomBorder {
  border-bottom: 2px solid var(--lightGray);
  padding: 8px;
}

.checkboxContainer {
  display: flex;
  align-items: center;
  background-color: var(--white);
  width: 300px;
  height: 30px;
  border-radius: 4px;
  border: 2px solid var(--lightGray);
  margin-bottom: 20px;
  padding: 6px;
}

.checkboxContainer:hover {
  cursor: pointer;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}

.checkboxContainerChecked {
  border: 2px solid var(--indigo);
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}

.checkboxLabel {
  font-weight: 600;
  margin-left: 30px;
}

.equalsContainer {
  padding-right: 64px;
}

.dropdownContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 48px;
}

.editButtonText {
  border-bottom: 2px solid var(--indigo);
}

.flexColumn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.flexRowSpaceBetween {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flexRowGap {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 16px;
}

.jiraStatusRow {
  max-height: 48px;
  min-height: 48px;
}

.multiselectContainer {
  display: flex;
  background-color: var(--white);
  padding: 16px;
  column-gap: 32px;
  justify-content: space-between;
  align-items: center;
  border: 2px solid var(--lightGray);
}
.projectSettingsContainer {
  display: flex;
  flex-direction: column;
  padding: 32px;
  gap: 32px;
  max-width: 33%;
  min-width: 370px;
}

.statusListContainer {
  display: flex;
  flex-direction: column;
  padding: 32px;
  gap: 32px;
}

.statusBloomfilter {
  flex: 3;
}

.statusExternal {
  flex: 2;
}

.statusJira {
  flex: 0.6;
  margin-right: 10%;
  min-width: 250px;
}

.successDivider {
  height: 50%;
  width: 100%;
  border-bottom: 4px dashed var(--tangerine);
}

.successDividerContainer {
  flex: 1;
  height: 100%;
  display: flex;
  align-items: flex-start;
  padding: 0 12px;
}

.summaryItem {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 16px;
  border: 2px solid var(--lightGray);
}

.summaryLabel {
  font-weight: bolder;
  font-size: 16pt;
  margin: 0;
}
